import { FilterContext } from "@faire/deprecated-retailer-visitor-shared/components/Filters/FilterContext";
import {
  FilterState,
  useCreateFilterStore,
} from "@faire/deprecated-retailer-visitor-shared/components/Filters/FilterStore";
import { useCategoryPageQueryParams } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/hooks/useCategoryPageQueryParams";
import { useLoggedOutCategoryPageFilterSections } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/DataFetching/useLoggedOutCategoryPageCatNav/useLoggedOutCategoryPageFilterSections";
import { getSelectedFilterKeys } from "@faire/retailer-shared/filters/getFilterOptions";
import cloneDeep from "lodash/cloneDeep";
import React, { ReactNode, useCallback, useEffect } from "react";

export const LoggedOutCategoryPageFilterStoreProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const {
    isFetching,
    data: { filterSections },
  } = useLoggedOutCategoryPageFilterSections();

  const { setFilterKeys } = useCategoryPageQueryParams();

  const onFilterSelected = useCallback(
    (state: FilterState) => {
      const filterKeys = getSelectedFilterKeys(state.filterSections);
      setFilterKeys(() => filterKeys);
    },
    [setFilterKeys]
  );

  const filterStore = useCreateFilterStore(
    FilterState.build({
      isSideBarVisible: false,
      shouldShowFilterCollapsePill: true,
      hideOptionsResultCount: true,
    }),

    onFilterSelected
  );
  useEffect(() => {
    if (filterSections.length > 0 && !isFetching) {
      filterStore.setState((currentState) => ({
        ...currentState,
        filterSections: cloneDeep(filterSections),
        isNewFilterSelected: false,
      }));
    }
  }, [filterStore, isFetching, filterSections]);

  return (
    <FilterContext.Provider value={filterStore}>
      {children}
    </FilterContext.Provider>
  );
};
